import { IconButton, Stack } from '@fluentui/react';
import React, { useState } from 'react';
import { NotificationCycleRowItem } from '../list';
import { NotificationCycleModal } from './NotificationCycleModal';

export interface NotificationCycleViewProps {
  notificationCycle: NotificationCycleRowItem;
}
export const NotificationCycleModalView: React.FC<NotificationCycleViewProps> = ({
  notificationCycle,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { _isUpdatable } = { ...notificationCycle };

  return (
    <Stack horizontal verticalAlign="center">
      <IconButton
        iconProps={{ iconName: 'Edit' }}
        onClick={() => setIsOpen(true)}
        disabled={!_isUpdatable}
      />
      {isOpen && (
        <NotificationCycleModal
          notificationCycle={notificationCycle}
          onClose={() => setIsOpen(false)}
        />
      )}
    </Stack>
  );
};
